
import React, { forwardRef } from 'react'

import './InputDropdownToggle.scss'

interface Props {
  children: any
  onClick: (e: any) => void
}

const InputDropdownToggle = forwardRef(({ children, onClick }: Props, ref: any) => {

  return (
    <div
      ref={ref}
      className='input-dropdown-toggle'
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </div>
  )
})

InputDropdownToggle.displayName = 'InputDropdownToggle'

export default InputDropdownToggle
